"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferenceScheduleCms = void 0;
var PreferenceScheduleCms = /** @class */ (function () {
    function PreferenceScheduleCms() {
        this.availabilityTitleLabel = 'My Availability';
        this.preferenceScheduleEarliestAppointmentRadioLabel = 'I prefer the earliest available appointment.';
        this.preferenceScheduleEarliestAppointmentLabel = 'Earliest available appointment';
        this.preferenceScheduleEmailDateTimeConsentLabel = ' (We\'ll email you the exact date and timeframe.)';
        this.preferenceScheduleEarliestDescriptionLabel = 'Earliest available appointment';
        this.preferenceSchedulePickSpecificDateLinkLabel = 'Pick a specific day and timeframe';
        this.preferenceSchedulePanelDescriptionLabel = "Standard installations take an average of 4 hours.\n        Some installations may require morning or full-day appointments.";
        this.preferenceScheduleAppointmentPreferenceQuestionLabel = 'Tell us when you prefer an appointment.';
        this.preferenceScheduleAppointmentPreferenceTitleLabel = 'Appointment preference';
    }
    return PreferenceScheduleCms;
}());
exports.PreferenceScheduleCms = PreferenceScheduleCms;
//# sourceMappingURL=PreferenceSchedule.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/ScheduleInstallPanel/InstallationCard/PreferenceSchedule/PreferenceSchedule.cms.js
// module id = 961
// module chunks = 8